import React from 'react';
import {
  FlowNodeCard as FlowNodeCardContainer,
  FlowNodeHeader,
  FlowNodeIcon,
  FlowNodeTitle,
  FlowNodeBody,
  StatusTable,
  FlowNodeDelayMeta,
  FlowNodeMessagePreview,
} from './FlowBuilder.styles';

const FlowNodeCard = ({ node, config, selected, onSelect, getNodeStats, onStatClick }) => {
  if (!config) return null;

  const stats = getNodeStats(node.id);

  const handleStatClick = (e, status) => {
    e.stopPropagation();
    if (onStatClick) onStatClick({ nodeId: node.id, nodeLabel: config.label, status });
  };

  return (
    <FlowNodeCardContainer data-interactive $selected={selected} onClick={onSelect}>
      <FlowNodeHeader>
        <FlowNodeIcon $bgColor={config.bgColor} $color={config.color}>
          {config.icon}
        </FlowNodeIcon>
        <FlowNodeTitle>
          {config.label}
          {node.type === 'delay' && (node.data.delayValue || node.data.delay) ? (
            <FlowNodeDelayMeta>
              {' '}— {node.data.delayValue || node.data.delay} {node.data.delayUnit || 'days'}
            </FlowNodeDelayMeta>
          ) : null}
        </FlowNodeTitle>
      </FlowNodeHeader>

      {(node.type === 'send_ai_email' || node.type === 'send_linkedin_ai_message') && node.data.offerName && (
        <FlowNodeBody>
          <FlowNodeMessagePreview>
            {node.data.offerName}
          </FlowNodeMessagePreview>
        </FlowNodeBody>
      )}

      {node.data.message && node.type !== 'send_ai_email' && node.type !== 'send_linkedin_ai_message' && (
        <FlowNodeBody>
          <FlowNodeMessagePreview>
            {node.data.message.substring(0, 50)}
            {node.data.message.length > 50 ? '...' : ''}
          </FlowNodeMessagePreview>
        </FlowNodeBody>
      )}

      {node.type === 'send_email' && node.data.emailSubject && (
        <FlowNodeBody>
          <FlowNodeMessagePreview>
            {node.data.emailSubject.length > 50
              ? node.data.emailSubject.substring(0, 50) + '...'
              : node.data.emailSubject}
          </FlowNodeMessagePreview>
        </FlowNodeBody>
      )}

      <FlowNodeBody>
        <StatusTable>
          <thead>
            <tr>
              <th>Task Status</th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody>
            <tr data-clickable="true" onClick={e => handleStatClick(e, 'completed')}>
              <td className="status-completed">Completed</td>
              <td className="count">{stats.completed}</td>
            </tr>
            <tr data-clickable="true" onClick={e => handleStatClick(e, 'failed')}>
              <td className="status-failed">Failed</td>
              <td className="count">{stats.failed}</td>
            </tr>
            <tr data-clickable="true" onClick={e => handleStatClick(e, 'running')}>
              <td className="status-progress">In Progress</td>
              <td className="count">{stats.inProgress}</td>
            </tr>
          </tbody>
        </StatusTable>
      </FlowNodeBody>
    </FlowNodeCardContainer>
  );
};

export default FlowNodeCard;
